import i18n from './i18next';

export const translate = (key, capitalizeString = true, params) => {
   const tr = i18n.t(key);
   if (capitalizeString) {
      return tr[0].toUpperCase() + tr.slice(1);
   }

   return tr;
};

export const t = (key, capitalizeString = true, params) => {
   return translate(key, capitalizeString, params);
};